import { PointsExpiration } from 'api/points'
import HeaderCell from 'components/HeaderCell'
import { buildTranslate } from 'locales'
import React from 'react'
import Row from './Row'

const t = buildTranslate('users.view.activity.points_expiration.table')

type PropsT = {
  expirations: PointsExpiration[]
  currencyName: string
  userIdentifier: string
}

const Table: React.FC<PropsT> = ({
  expirations,
  currencyName,
  userIdentifier,
}: PropsT) => {
  return (
    <table className="full-width">
      <thead>
        <tr>
          <HeaderCell>{t('amount')}</HeaderCell>
          <HeaderCell>{t('expiration_date')}</HeaderCell>
          <HeaderCell>{t('status')}</HeaderCell>
          <HeaderCell>{t('actions')}</HeaderCell>
        </tr>
      </thead>
      <tbody>
        {expirations.map(expiration => (
          <Row
            key={
              expiration.id ||
              `${expiration.expiration_date}-${expiration.amount}-${expiration.status}`
            }
            expiration={expiration}
            currencyName={currencyName}
            userIdentifier={userIdentifier}
          />
        ))}
      </tbody>
    </table>
  )
}

export default Table
